


























































































import { ValidationObserver } from 'vee-validate';
import uaParser from 'ua-parser-js';
import { errorToMessage } from '@/core/utils/errors';
import NavItem from '@/web/components/navigation/NavItem.vue';
import { getStudioURL } from '@/web/router/custom-domain-utils';
import { mapGetters } from 'vuex';

const parsedUa = uaParser(window.navigator);

export default {
  components: {
    ValidationObserver,
    NavItem,
  },
  props: {
    onLoginFn: null,
    onResetPassword: null,
    signupName: {
      type: String,
      default: 'Signup',
    },
    showSignupLink: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      email: '',
      password: '',
      formError: null,
      inProgress: false,
      isIOS: parsedUa.os.name,
    };
  },
  computed: {
    ...mapGetters({
      isPWA: 'globals/isPWA',
    }),
  },
  methods: {
    login() {
      this.inProgress = true;
      this.$store
        .dispatch('user/login', {
          email: this.email,
          password: this.password,
        })
        .then(this.onLogin)
        .catch(error => {
          this.formError = errorToMessage(error.response);
        })
        .finally(() => (this.inProgress = false));
    },
    async onLogin(loginResponse: LoginResponse) {
      const studioURL = getStudioURL(this.$route);
      if (studioURL) {
        await this.$store.dispatch('studio/joinStudio', studioURL);
        this.$store.dispatch('studio/getStudio', studioURL);
      }
      if (this.onLoginFn) {
        this.$emit('close');
        await this.loadUserInfoSync();
        this.onLoginFn();
      } else {
        const { user_type } = loginResponse;
        const redirectUrl = this.$route.query.redirect;
        await this.loadUserInfoSync();
        this.$emit('onLogin');
        if (redirectUrl) {
          this.$router.replace(redirectUrl);
        } else {
          const redirectData = await this.$store.dispatch(
            'user/getLoginRedirectData',
            studioURL
          );
          this.$router.replace(redirectData);
        }
      }
    },
    async onForgotPassword() {
      if (this.onResetPassword) {
        this.onResetPassword();
      }
      this.$emit('onResetPassword');
      this.$emit('close');
    },
    async loadUserInfoSync() {
      let loadUserInfoPromise = this.$store.state.user.userInfoPromise;
      if (!loadUserInfoPromise) {
        loadUserInfoPromise = await this.$store.dispatch('user/loadUserInfo');
      } else {
        loadUserInfoPromise
          .finally()
          .then(
            async () =>
              (loadUserInfoPromise = await this.$store.dispatch(
                'user/loadUserInfo'
              ))
          );
      }
      await loadUserInfoPromise;
    },
    socialLoginError(error) {
      let errorMessage;
      switch (error.code) {
        case 'auth/account-exists-with-different-credential':
          errorMessage = this.$t('LOGIN.TEXT.WE_VE_GOT_AN_ACCOUNT_WITH_THIS');
          break;
        default:
          errorMessage = errorToMessage(error.response);
          break;
      }

      this.$notify({
        group: 'app',
        type: 'error',
        text: errorMessage,
      });
    },
    async facebookLogin() {
      try {
        const provider = new this.$firebase.auth.FacebookAuthProvider();
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithFacebook',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
    async googleLogin() {
      try {
        const provider = new this.$firebase.auth.GoogleAuthProvider();
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithGoogle',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
    async appleLogin() {
      try {
        const provider = new this.$firebase.auth.OAuthProvider('apple.com');
        provider.addScope('email');
        provider.addScope('name');
        const result = await this.$firebase.auth().signInWithPopup(provider);
        const loginResponse = await this.$store.dispatch(
          'user/loginWithApple',
          result.credential.accessToken
        );
        this.onLogin(loginResponse);
      } catch (error) {
        this.socialLoginError(error);
      }
    },
  },
};
